import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import React, { VFC, useState } from "react";
import styled from "styled-components";
import Modal from "~/components/atoms/Modal";
import Button from "~/components/atoms/button";
import UnstyledButton from "~/components/atoms/button/UnstyledButton";
import QaReviewCommentForm, {
  CommentCallbackResponse,
  QaCommentCallbackData,
} from "~/components/modules/QaReviewCommentForm/QaReviewCommentForm";
import FixedFooterWrap from "~/components/modules/fixedFooter/LayoutWrap";
import { generateQaDetailPath } from "~/lib/utils/urlHelper";
import { QuestionAnswer } from "~/models/questionAnswer";
import { QuestionAnswerContentRevision } from "~/models/questionAnswer/contentRevision";
import { Task } from "~/models/task";
import { Topic } from "~/models/topic";

interface Props {
  onSubmitQaReviewComment: (
    data: QaCommentCallbackData
  ) => Promise<CommentCallbackResponse>;
  questionAnswer: QuestionAnswer;
  revisionStatus?: QuestionAnswerContentRevision["status"];
  task?: Task;
  topic: Topic;
}

const AnswerReviewControlButtons: VFC<Props> = ({
  onSubmitQaReviewComment,
  questionAnswer,
  revisionStatus,
  task,
  topic,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleCommentClick = () => {
    setIsOpen(true);
  };

  const handleCommentClose = () => {
    setIsOpen(false);
  };

  const handleCommentSuccess = () => {
    setIsOpen(false);
  };

  return (
    <>
      <FixedFooterWrap>
        <Container>
          <UnstyledButton onClick={handleCommentClick} type="button">
            <Button
              variant="outline"
              text={t("common:button.overall-comment")}
            />
          </UnstyledButton>
          <Link
            href={generateQaDetailPath({
              questionAnswer,
              topicSlug: topic.slug,
            })}
            passHref
          >
            <a>
              <Button text={t("common:button.back-to-article")} />
            </a>
          </Link>
        </Container>
      </FixedFooterWrap>
      <Modal isOpen={isOpen} onClose={handleCommentClose} bgColor="#fff">
        <QaReviewCommentForm
          onSuccess={handleCommentSuccess}
          onSubmitQaReviewCommentCallback={onSubmitQaReviewComment}
          questionAnswer={questionAnswer}
          reviewMode="forNormalUser"
          revisionStatus={revisionStatus}
          targetQaField="overview"
          taskId={task?.id}
          withTalkRoomForm={false}
        />
      </Modal>
    </>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 16px;
`;

export default AnswerReviewControlButtons;
